import React, { Component } from 'react';
import { connect } from 'react-redux';
import { I18n, Translate } from 'react-redux-i18n';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ButtonMui from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import Switch from '@material-ui/core/Switch';
import Alert from '../../../../Components/Alert';
import { Input, InputAdornment } from '@material-ui/core';
import './index.scss';

class PartnerTaxRate extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: false,
		};
	}

	openModal = () => {
		this.setState({
			open: true,
		});
	};

	closeModal = () => {
		this.setState({
			open: false,
		});
	};

	onValid = e => {
		e.preventDefault();

		this.props.onSavePartnerTaxRate();
		this.closeModal();
	};

	onSwitchChange = e => {
		this.props.onChangePartnerTaxRate(
			this.props.prefix,
			e.target.name,
			e.target.checked ? '0' : null
		);
	};

	onInputChange = e => {
		let value = e.target.value;
		if (value >= 1 && value[0] == 0) value = value.slice(1);
		if (!value || value === '') value = '0';
		value = value.replace(',', '.');

		this.props.onChangePartnerTaxRate(this.props.prefix, e.target.name, value);
	};

	render() {
		return (
			<div className="gestion-button-container">
				<div>
					<ButtonMui onClick={this.openModal} variant={'outlined'}>
						<Translate value={'partner_tax_rate.button'} />
					</ButtonMui>
					<Dialog
						onClose={this.closeModal}
						open={this.state.open}
						id={'dialog-payment-types'}>
						<DialogTitle>
							<Translate value={'partner_tax_rate.title'} />
						</DialogTitle>
						<DialogContent>
							<Alert type="info">{I18n.t('partner_tax_rate.help')}</Alert>
							{this.props.product_types.map(pt => {
								const value = this.props.tax_rates.find(
									tr => tr.product_type == pt.id
								);
								return (
									<div className="partner_tax_rate_row">
										<span>{pt.name} : </span>
										<div className="partner_tax_rate_switch">
											<p className={!value ? '' : 'tax_rate_switch_disabled'}>
												{I18n.t('partner_tax_rate.switch_default')}
											</p>

											<Switch
												checked={!!value}
												onChange={this.onSwitchChange}
												name={pt.id}
											/>
											<p className={!!value ? '' : 'tax_rate_switch_disabled'}>
												{I18n.t('partner_tax_rate.switch_custom')}
											</p>
										</div>
										{!!value ? (
											<Input
												type="text"
												value={value.tax_rate}
												onChange={this.onInputChange}
												name={pt.id}
												endAdornment={
													<InputAdornment position="end">%</InputAdornment>
												}
												inputProps={{
													width: 30,
												}}
											/>
										) : null}
									</div>
								);
							})}
						</DialogContent>
						<DialogActions>
							{' '}
							<ButtonMui onClick={this.closeModal}>
								<Translate value={'general.cancel'} />
							</ButtonMui>
							<ButtonMui
								onClick={this.onValid}
								//disabled={!btnEnabled}
								color="primary"
								autoFocus>
								<Translate value={'general.valid'} />
							</ButtonMui>
						</DialogActions>
					</Dialog>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state, props) => {
	const tax_rates =
		state.exports.partnerTaxRates && state.exports.partnerTaxRates
			? state.exports.partnerTaxRates.filter(
					ptr => ptr.partner_prefix === props.prefix
			  )
			: [];
	return {
		product_types: state.exports.productsSelector.products.product_types || [],
		tax_rates,
	};
};

const mapDispatchToProps = dispatch => {
	return {
		onChangePartnerTaxRate: (prefix, product_type, rate) =>
			dispatch({ type: 'EDIT_PARTNER_TAX_RATES', prefix, product_type, rate }),
		onSavePartnerTaxRate: () => dispatch({ type: 'SAVE_PARTNER_TAX_RATE' }),
	};
};
export default connect(mapStateToProps, mapDispatchToProps)(PartnerTaxRate);
